import React from 'react';
import {connect} from 'react-redux';
import {trackingDomainActions} from '../../../store/actions/trackingDomainAction';
import {userSettingsActions} from '../../../store/actions/userSettingsAction';
import DomainList from './DomainList';

export function TrackingDomainsList(props) {
    const setDefault = domain => {
        if (domain?.domain) {
            props.updateUserSettings({defaultTrackingDomain: domain.domain});
            props.setNewDefaultTrackingDomain(domain.domain);
        }
    };
    return <DomainList {...props} kind="tracking" setDefault={setDefault}/>;
}

export default connect(null, {
    setNewDefaultTrackingDomain: trackingDomainActions.setNewDefaultTrackingDomain,
    remove: trackingDomainActions.remove,
    updateUserSettings: userSettingsActions.update
})(TrackingDomainsList);
